import { UserDetailView } from '@/domains/users/components/UserDetailView';
import { Button } from '@/shared/ui/button';
import { AlertCircle, Loader2 } from 'lucide-react';
import { useNavigate, useParams } from 'react-router';
import { useUser } from '../hooks/useUsers';
import { userDetailToView } from '../utils/mappers';

export function UserDetailPage() {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const { data: userDetail, isLoading, isError } = useUser(userId || '');

  if (!userId) return null;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <Loader2 className="w-8 h-8 mx-auto mb-3 animate-spin text-muted-foreground" />
          <p className="text-muted-foreground">Loading user...</p>
        </div>
      </div>
    );
  }

  if (isError || !userDetail) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-red-400" />
          <p className="text-muted-foreground mb-4">Failed to load user details</p>
          <Button variant="outline" onClick={() => navigate('/users')}>
            Back to Users
          </Button>
        </div>
      </div>
    );
  }

  return (
    <UserDetailView
      userId={userId}
      userDetail={userDetail}
      user={userDetailToView(userDetail)}
      onBack={() => navigate('/users')}
    />
  );
}
